import { createSelector } from 'reselect'

const getLessonsPicker = state => state.lessonsPicker
const getLibraries = state => state.libraries
const getLessons = state => state.lessons

const privateLibraryLessonsPickerModalSaveSelector = createSelector(
	[ getLessonsPicker, getLibraries, getLessons ],
	(lessons_picker, libraries, lessons) => {

		const lessonsUIDs = lessons_picker.selected_lessons
			.filter(id => lessons[id].library_object_type==='1')
			.map(id => lessons[id].data.id)

		const bundlesUIDs = lessons_picker.selected_lessons.filter(entityUID => lessons[entityUID].library_object_type==='3')

		return {
			entityUID: libraries.current.folderUID,
			lessonsUIDs,
			bundlesUIDs,
			libraryUID: libraries.current.libraryUID,
		}
	}
)

export default privateLibraryLessonsPickerModalSaveSelector
